const Syncing=()=>{
    // return <i className="pi pi-spin pi-sync" style={{ fontSize: '1.5rem',margin:'5px' }}></i>
    return <i className="pi pi-sync text-white" style={{ fontSize: '1.5rem' }}></i>
}
export default Syncing;